import type { ReactElement } from 'react';
import type { DemoAccountDto } from '@gr/core/platform/operations/dto';
import { useT } from '../../../../app/di';
import { Card } from '../../../../ui-kit/Card/Card';
import { ChoiceGroup, ChoiceTile } from '../../../../ui-kit/Choice/Choice';
import styles from './DemoAccountList.module.scss';

/** DEMO-UC-1: демо-учётки на странице входа; выбор подставляет логин и пароль. */
export function DemoAccountList({ accounts, onPick }: { accounts: readonly DemoAccountDto[]; onPick(account: DemoAccountDto): void }): ReactElement {
  const { t } = useT();
  return (
    <Card title={t('identity.login.demoTitle')}>
      <div className="u-stack">
        <p className="u-muted u-small">{t('identity.login.demoText')}</p>
        <ChoiceGroup label={t('identity.login.demoTitle')} columns="one">
          {accounts.map((account) => (
            <ChoiceTile key={account.login} onSelect={() => onPick(account)}>
              <span className={styles.account}>
                <strong>{account.login}</strong>
                <span className="u-muted">
                  {t(`identity.login.demoRole.${account.blogRole ?? 'admin'}`)} · {account.password}
                </span>
              </span>
            </ChoiceTile>
          ))}
        </ChoiceGroup>
      </div>
    </Card>
  );
}
